import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router';
import { SimulationModel } from '~/shared/models/system/SimulationModel';
import { waterLevelsMetricsQuery } from '~/shared/api/metrics.queries';
import { checkAuthorization } from '~/shared/auth/auth-utils';
import { WaterLevelsModel } from '~/shared/models/metrics/waterLevelsModel/WaterLevelsModel';
import { assertIsDefined } from '~/types/assert-type';
import { getSystemSimulationQuery } from '~/shared/api/simulations.queries';

export type SystemPageInSimulationLoaderData = {
  simulation: SimulationModel;
  waterLevels: WaterLevelsModel;
};

export const systemPageInSimulationLoader =
  (queryClient: QueryClient) =>
  async ({
    params,
    request,
  }: LoaderFunctionArgs): Promise<
    SystemPageInSimulationLoaderData | Response
  > => {
    await checkAuthorization(queryClient, request);

    const { simulationId } = params;

    assertIsDefined(simulationId);

    const simulation = await queryClient.ensureQueryData(
      getSystemSimulationQuery({ simulationId }),
    );

    const { system } = simulation;

    const systemReservoirs = system.getReservoirNames();

    const waterLevels = await queryClient.ensureQueryData(
      waterLevelsMetricsQuery({ reservoirNames: systemReservoirs, simulation }),
    );

    return {
      simulation,
      waterLevels,
    };
  };
